import { useTemplatePreviewStore } from '@apps/guest/routes/GuestSite/TemplatePreviewContext';

type MonogramPersonalizationOverrides = Readonly<{
  initials: ReadonlyArray<string> | undefined;
  eventDate: number | null | undefined;
}>;

/**
 * Returns monogram personalization overrides (initials, event date) from the active
 * template preview payload, if one is present. Both fields are undefined outside of
 * a template preview session.
 */
export const useMonogramPersonalizationOverrides = (): MonogramPersonalizationOverrides => {
  const templatePreview = useTemplatePreviewStore();
  const activePayload = templatePreview.getActivePayload();
  return {
    initials: activePayload?.previewInitials,
    eventDate: activePayload?.previewEventDate,
  };
};
